import React, { useState, useEffect } from "react";
import axios from "axios";
import './ProductManager.css';
import { useSelector } from "react-redux";

function ProductManager({ onProductAdded, onSubProductAdded }) {
  const [newProductName, setNewProductName] = useState("");
  const [newProductCategory, setNewProductCategory] = useState("FOOD");
  const [newSubProductName, setNewSubProductName] = useState("");
  const [newSubProductPrice, setNewSubProductPrice] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [products, setProducts] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);

  const currentUser = useSelector((state) => state?.AuthReducer?.user);

  console.log("🔍 [RENDER] ProductManager - currentUser:", currentUser);

  // Fonction utilitaire pour extraire l'ID de localisation
  const extractLocId = (loc) => {
    if (!loc) {
      console.log("📍 extractLocId: localisation null/undefined");
      return null;
    }
    if (typeof loc === "string") {
      console.log("📍 extractLocId: string ->", loc);
      return loc;
    }
    if (loc.$oid) {
      console.log("📍 extractLocId: $oid ->", loc.$oid);
      return loc.$oid;
    }
    if (loc._id) {
      const id = loc._id.toString();
      console.log("📍 extractLocId: _id ->", id);
      return id;
    }
    console.log("📍 extractLocId: format non reconnu ->", loc);
    return null;
  };

  // Charger les localisations
  useEffect(() => {
    const fetchLocations = async () => {
      try {
        console.log("🔄 Début chargement localisations...");
        const token = localStorage.getItem("token");
        console.log("🔑 Token:", token ? "PRÉSENT" : "ABSENT");
        
        const response = await axios.get("/api/Locationspin/getAllLocations", {
          headers: { Authorised: token }
        });
        
        console.log("📡 Réponse API localisations:", response);
        
        let locationsData = [];
        if (Array.isArray(response.data)) {
          locationsData = response.data;
        } else if (response.data?.locations) {
          locationsData = response.data.locations;
        } else if (response.data?.data) {
          locationsData = response.data.data;
        }
        
        console.log("📍 Localisations traitées:", locationsData);
        setLocations(locationsData);
        
      } catch (error) {
        console.error("❌ Erreur chargement localisations:", error);
        console.error("❌ Détails erreur:", error.response?.data);
      }
    };

    if (currentUser) {
      fetchLocations();
    }
  }, [currentUser]);

  // Charger les produits
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        console.log("🔄 Début chargement produits...");
        const token = localStorage.getItem("token");
        const response = await axios.get("/api/Product/getProduct", {
          headers: { Authorised: token }
        });
        
        console.log("📦 Produits chargés:", response.data);
        setProducts(response.data || []);
        
      } catch (error) {
        console.error("❌ Erreur chargement produits:", error);
        console.error("❌ Détails erreur:", error.response?.data);
      }
    };

    if (currentUser) {
      fetchProducts();
    }
  }, [currentUser]);

  // Initialiser les localisations sélectionnées
  useEffect(() => {
    console.log("📍 useEffect selectedLocations - currentUser:", currentUser, "locations:", locations.length);
    
    if (currentUser && locations.length > 0) {
      console.log("📍 Initialisation localisations pour:", currentUser.role);
      
      if (currentUser.role === "admin") {
        const allLocationIds = locations.map(loc => extractLocId(loc._id)).filter(Boolean);
        console.log("📍 Admin - Toutes localisations:", allLocationIds);
        setSelectedLocations(allLocationIds);
      } else {
        const userLocId = extractLocId(currentUser.localisation?._id || currentUser.localisation);
        console.log("📍 Non-admin - Localisation utilisateur:", userLocId);
        if (userLocId) {
          setSelectedLocations([userLocId]);
        }
      }
    }
  }, [currentUser, locations]);

  // 🔥 FONCTION AJOUT PRODUIT AVEC LOGGING COMPLET
  const addProductHandler = async () => {
    console.log("🎯 DÉBUT addProductHandler");
    console.log("📝 Données formulaire:", {
      newProductName,
      newProductCategory,
      currentUser: currentUser ? {
        name: currentUser.name,
        role: currentUser.role,
        localisation: currentUser.localisation
      } : "NULL"
    });

    // Validation
    if (!newProductName.trim()) {
      console.log("❌ Validation échouée: nom manquant");
      alert("Veuillez entrer un nom pour le produit.");
      return;
    }

    if (!currentUser) {
      console.log("❌ Validation échouée: utilisateur non connecté");
      alert("Utilisateur non connecté.");
      return;
    }

    if (currentUser.role !== "admin" && !currentUser.localisation) {
      console.log("❌ Validation échouée: localisation manquante pour non-admin");
      alert("Votre compte n'a pas de localisation définie.");
      return;
    }

    setLoading(true);

    try {
      const token = localStorage.getItem("token");
      console.log("🔑 Token pour requête:", token ? "PRÉSENT" : "ABSENT");

      // Déterminer la localisation
      let productLocalisation = null;
      
      if (currentUser.role !== "admin") {
        productLocalisation = extractLocId(currentUser.localisation?._id || currentUser.localisation);
        console.log("📍 Non-admin - Localisation déterminée:", productLocalisation);
      } else {
        productLocalisation = selectedLocations.length > 0 ? selectedLocations[0] : null;
        console.log("📍 Admin - Localisation déterminée:", productLocalisation);
      }

      const productData = { 
        name: newProductName, 
        category: newProductCategory,
        localisation: productLocalisation
      };

      console.log("📤 DONNÉES ENVOYÉES AU BACKEND:", JSON.stringify(productData, null, 2));
      console.log("🌐 URL: /api/Product/AddProduct");
      console.log("🔑 HEADERS:", { Authorised: token });

      // 🔥 APPEL API CRITIQUE
      console.log("🚀 ENVOI DE LA REQUÊTE POST...");
      const response = await axios.post("/api/Product/AddProduct", productData, {
        headers: { 
          Authorised: token,
          'Content-Type': 'application/json'
        },
        timeout: 10000 // 10 secondes timeout
      });

      console.log("✅ RÉPONSE BACKEND RECUE!");
      console.log("📊 Statut:", response.status);
      console.log("📦 DONNÉES RETOURNÉES:", response.data);

      if (response.status === 201) {
        console.log("🎉 PRODUIT CRÉÉ AVEC SUCCÈS!");
        
        // Réinitialisation
        setNewProductName("");
        setNewProductCategory("FOOD");
        
        // Mettre à jour la liste des produits
        setProducts(prev => {
          const newProducts = [...prev, response.data];
          console.log("🔄 Liste produits mise à jour:", newProducts.length, "produits");
          return newProducts;
        });

        onProductAdded?.(response.data);
        alert("✅ Produit ajouté avec succès !");
      } else {
        console.warn("⚠️ Réponse inattendue:", response.status);
        alert("Réponse inattendue du serveur");
      }

    } catch (error) {
      console.error("❌ ERREUR CRITIQUE addProductHandler:", error);
      
      if (error.response) {
        // Erreur du serveur
        console.error("❌ Réponse erreur:", error.response.status);
        console.error("❌ Données erreur:", error.response.data);
        alert(`Erreur serveur (${error.response.status}): ${error.response.data?.message || "Erreur inconnue"}`);
      } else if (error.request) {
        // Pas de réponse du serveur
        console.error("❌ Pas de réponse du serveur:", error.request);
        alert("Erreur: Le serveur ne répond pas. Vérifiez votre connexion.");
      } else {
        // Erreur de configuration
        console.error("❌ Erreur de configuration:", error.message);
        alert(`Erreur: ${error.message}`);
      }
    } finally {
      setLoading(false);
      console.log("🏁 FIN addProductHandler - loading:", false);
    }
  };

  // Fonction pour obtenir les localisations disponibles
  const getAvailableLocations = () => {
    if (!currentUser) {
      console.log("📍 getAvailableLocations: utilisateur non connecté");
      return [];
    }
    
    if (currentUser.role === "admin") {
      console.log("📍 getAvailableLocations: admin -> toutes les localisations");
      return locations;
    } else {
      const userLocId = extractLocId(currentUser.localisation?._id || currentUser.localisation);
      const filtered = locations.filter(loc => extractLocId(loc._id) === userLocId);
      console.log("📍 getAvailableLocations: non-admin ->", filtered.length, "localisations");
      return filtered;
    }
  };

  const availableLocations = getAvailableLocations();

  // Gérer la sélection des localisations
  const handleLocationChange = (locationId) => {
    console.log("📍 Changement sélection localisation:", locationId);
    setSelectedLocations(prev => {
      const newSelection = prev.includes(locationId) 
        ? prev.filter(id => id !== locationId)
        : [...prev, locationId];
      console.log("📍 Nouvelle sélection:", newSelection);
      return newSelection;
    });
  };

  // Sélectionner/désélectionner toutes les localisations
  const toggleAllLocations = () => {
    console.log("📍 toggleAllLocations");
    if (selectedLocations.length === availableLocations.length) {
      setSelectedLocations([]);
      console.log("📍 Toutes désélectionnées");
    } else {
      const allLocationIds = availableLocations.map(loc => extractLocId(loc._id)).filter(Boolean);
      setSelectedLocations(allLocationIds);
      console.log("📍 Toutes sélectionnées:", allLocationIds);
    }
  };

  // Ajouter un sous-produit
  const addSubProductHandler = async () => {
    console.log("🎯 DÉBUT addSubProductHandler");
    
    if (!selectedProduct || !newSubProductName.trim() || !newSubProductPrice || selectedLocations.length === 0) {
      alert("Veuillez remplir tous les champs obligatoires et sélectionner au moins une localisation.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      
      console.log("📤 Création sous-produits pour localisations:", selectedLocations);

      const promises = selectedLocations.map(locationId => {
        const subProductData = {
          name: newSubProductName,
          price: parseFloat(newSubProductPrice),
          localisation: locationId
        };

        console.log(`📤 Sous-produit pour ${locationId}:`, subProductData);

        return axios.post(`/api/Product/${selectedProduct}/subproduct`, subProductData, {
          headers: { Authorised: token, 'Content-Type': 'application/json' }
        });
      });

      const results = await Promise.all(promises);
      console.log("✅ Sous-produits créés:", results.map(r => r.data));

      setNewSubProductName("");
      setNewSubProductPrice("");
      
      // Ne pas réinitialiser complètement, garder la sélection actuelle
      if (currentUser.role !== "admin") {
        const userLocId = extractLocId(currentUser.localisation?._id);
        setSelectedLocations(userLocId ? [userLocId] : []);
      }

      alert(`${selectedLocations.length} sous-produit(s) ajouté(s) avec succès !`);
      
      onSubProductAdded?.();

      // Recharger les produits
      const productsResponse = await axios.get("/api/Product/getProduct", {
        headers: { Authorised: token }
      });
      setProducts(productsResponse.data);

    } catch (error) {
      console.error("❌ Erreur ajout sous-produit:", error);
      console.error("❌ Détails erreur:", error.response?.data);
      alert(`Erreur: ${error.response?.data?.message || error.message}`);
    }
  };

  // Supprimer un produit
  const deleteProductHandler = async () => {
    if (!selectedProduct || !window.confirm("Êtes-vous sûr de vouloir supprimer ce produit ?")) return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(`/api/Product/deleteProduct/${selectedProduct}`, {
        headers: { Authorised: token }
      });
      
      setProducts(prev => prev.filter(p => p._id !== selectedProduct));
      setSelectedProduct("");
      alert("Produit supprimé avec succès !");
    } catch (error) {
      console.error("Erreur suppression produit:", error);
      alert("Erreur lors de la suppression.");
    }
  };

  console.log("🔍 [RENDER] State actuel:", {
    productsCount: products.length,
    locationsCount: locations.length,
    selectedLocationsCount: selectedLocations.length,
    loading,
    currentUser: currentUser ? "PRÉSENT" : "ABSENT"
  });

  return (
    <div className="product-manager">
      <h2>Gestion des Produits - DEBUG</h2>

      {/* Section de debug visible */}
      <div style={{ 
        background: '#f0f8ff', 
        padding: '15px', 
        margin: '15px 0', 
        border: '2px solid #007acc',
        borderRadius: '8px'
      }}>
        <h4 style={{ margin: '0 0 10px 0', color: '#007acc' }}>🔍 ÉTAT ACTUEL DU SYSTÈME</h4>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px' }}>
          <div><strong>Utilisateur:</strong> {currentUser?.name || "Non connecté"}</div>
          <div><strong>Rôle:</strong> {currentUser?.role || "Non défini"}</div>
          <div><strong>Localisation user:</strong> {currentUser?.localisation?.name || "Non définie"}</div>
          <div><strong>Produits chargés:</strong> {products.length}</div>
          <div><strong>Localisations disponibles:</strong> {availableLocations.length}</div>
          <div><strong>Localisations sélectionnées:</strong> {selectedLocations.length}</div>
        </div>
        <button 
          onClick={() => console.log("🔍 DEBUG COMPLET:", {
            currentUser,
            products,
            locations,
            selectedLocations,
            availableLocations
          })}
          style={{ 
            margin: '10px 5px 0 0', 
            padding: '8px 12px',
            background: '#007acc',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Log Debug Complet
        </button>
        <button 
          onClick={() => {
            const token = localStorage.getItem("token");
            console.log("🔑 Token stocké:", token);
            console.log("👤 User Redux:", currentUser);
          }}
          style={{ 
            margin: '10px 5px 0 0', 
            padding: '8px 12px',
            background: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Check Auth
        </button>
      </div>

      {/* Section Ajout de produit */}
      <section style={{ 
        border: '3px solid #4CAF50', 
        padding: '20px', 
        margin: '15px 0',
        borderRadius: '8px',
        background: '#f9f9f9'
      }}>
        <h3 style={{ color: '#4CAF50', marginBottom: '15px' }}>➕ TEST AJOUT PRODUIT</h3>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Nom du produit: 
          </label>
          <input
            type="text"
            value={newProductName}
            onChange={(e) => {
              console.log("📝 Changement nom produit:", e.target.value);
              setNewProductName(e.target.value);
            }}
            placeholder="Entrez le nom du produit"
            style={{ 
              width: '100%', 
              padding: '10px', 
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          />
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Catégorie: 
          </label>
          <select 
            value={newProductCategory} 
            onChange={(e) => {
              console.log("📝 Changement catégorie:", e.target.value);
              setNewProductCategory(e.target.value);
            }}
            style={{ 
              width: '100%', 
              padding: '10px', 
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          >
            <option value="FOOD">FOOD</option>
            <option value="BEVERAGES">BEVERAGES</option>
            <option value="DEALS">DEALS</option>
          </select>
        </div>

        <div style={{ marginBottom: '15px', padding: '10px', background: '#fff3cd', borderRadius: '4px' }}>
          <strong>Localisation qui sera utilisée:</strong>
          <div>
            {currentUser?.role !== 'admin' ? (
              <span>📍 {currentUser?.localisation?.name || "Non définie"} (Localisation utilisateur)</span>
            ) : (
              <span>📍 {selectedLocations.length > 0 ? "Première localisation sélectionnée" : "Aucune localisation"}</span>
            )}
          </div>
        </div>

        <button 
          onClick={addProductHandler} 
          disabled={loading}
          style={{ 
            width: '100%',
            background: loading ? '#6c757d' : '#4CAF50', 
            color: 'white', 
            padding: '12px 20px',
            margin: '10px 0',
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: loading ? 'not-allowed' : 'pointer',
            transition: 'background 0.3s'
          }}
        >
          {loading ? "⏳ ENVOI EN COURS..." : "🚀 TESTER L'AJOUT DE PRODUIT"}
        </button>

        {loading && (
          <div style={{ textAlign: 'center', margin: '10px 0' }}>
            <p>⏳ Requête en cours d'envoi au serveur...</p>
          </div>
        )}
      </section>

      {/* Section Ajout de sous-produit */}
      <section style={{ 
        border: '2px solid #007acc', 
        padding: '20px', 
        margin: '15px 0',
        borderRadius: '8px',
        background: '#f9f9f9'
      }}>
        <h3 style={{ color: '#007acc', marginBottom: '15px' }}>Ajouter un Sous-Produit</h3>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Produit parent: 
          </label>
          <select 
            value={selectedProduct} 
            onChange={(e) => setSelectedProduct(e.target.value)}
            style={{ 
              width: '100%', 
              padding: '10px', 
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          >
            <option value="">Sélectionner un produit</option>
            {products.map(product => (
              <option key={product._id} value={product._id}>
                {product.name} ({product.category})
              </option>
            ))}
          </select>
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Nom du sous-produit: 
          </label>
          <input
            type="text"
            value={newSubProductName}
            onChange={(e) => setNewSubProductName(e.target.value)}
            placeholder="Nom du sous-produit"
            style={{ 
              width: '100%', 
              padding: '10px', 
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          />
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Prix: 
          </label>
          <input
            type="number"
            step="0.01"
            value={newSubProductPrice}
            onChange={(e) => setNewSubProductPrice(e.target.value)}
            placeholder="Prix"
            style={{ 
              width: '100%', 
              padding: '10px', 
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          />
        </div>

        {/* Sélection des localisations pour sous-produit */}
        <div className="locations-section" style={{ marginBottom: '20px' }}>
          <h4 style={{ marginBottom: '10px' }}>Localisations du sous-produit *</h4>
          
          {availableLocations.length > 0 ? (
            <div className="locations-selector">
              <button 
                type="button" 
                className="toggle-all-btn"
                onClick={toggleAllLocations}
                style={{
                  padding: '8px 12px',
                  background: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  marginBottom: '10px'
                }}
              >
                {selectedLocations.length === availableLocations.length ? 
                  "❌ Tout désélectionner" : "✅ Tout sélectionner"}
              </button>
              
              <div className="locations-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px' }}>
                {availableLocations.map(location => {
                  const locationId = extractLocId(location._id);
                  const isSelected = selectedLocations.includes(locationId);
                  
                  return (
                    <label key={locationId} className="location-checkbox" style={{ 
                      display: 'flex', 
                      alignItems: 'center',
                      padding: '8px',
                      border: `2px solid ${isSelected ? '#4CAF50' : '#ddd'}`,
                      borderRadius: '4px',
                      background: isSelected ? '#e8f5e8' : '#f9f9f9',
                      cursor: 'pointer'
                    }}>
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => handleLocationChange(locationId)}
                        style={{ marginRight: '8px' }}
                      />
                      <span className={`location-label ${isSelected ? 'selected' : ''}`}>
                        {location.name}
                      </span>
                    </label>
                  );
                })}
              </div>
              
              {selectedLocations.length > 0 && (
                <div className="selected-count" style={{ marginTop: '10px', padding: '8px', background: '#e7f3ff', borderRadius: '4px' }}>
                  {selectedLocations.length} localisation(s) sélectionnée(s)
                </div>
              )}
            </div>
          ) : (
            <p className="no-locations" style={{ color: '#6c757d' }}>Aucune localisation disponible</p>
          )}
        </div>

        <button 
          onClick={addSubProductHandler} 
          style={{ 
            width: '100%',
            background: '#007acc', 
            color: 'white', 
            padding: '12px 20px',
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          Ajouter Sous-Produit
        </button>
        
        {selectedProduct && (
          <button 
            onClick={deleteProductHandler}
            style={{ 
              width: '100%',
              background: '#dc3545', 
              color: 'white', 
              padding: '10px 20px',
              margin: '10px 0',
              border: 'none',
              borderRadius: '4px',
              fontSize: '14px',
              cursor: 'pointer'
            }}
          >
            Supprimer le produit sélectionné
          </button>
        )}
      </section>

      {/* Liste des produits existants */}
      <section style={{ margin: '20px 0' }}>
        <h3>Produits Existants ({products.length})</h3>
        {products.length > 0 ? (
          <div style={{ border: '1px solid #ddd', borderRadius: '4px', overflow: 'hidden' }}>
            {products.map((product, index) => (
              <div 
                key={product._id} 
                style={{ 
                  padding: '10px 15px', 
                  borderBottom: '1px solid #eee',
                  background: selectedProduct === product._id ? '#e7f3ff' : 'white'
                }}
              >
                <strong>{product.name}</strong> - {product.category}
                {product.localisation && <span style={{ marginLeft: '10px', color: '#6c757d' }}>📍 {product.localisation}</span>}
                <span style={{ marginLeft: '10px', color: '#28a745' }}>{product.subProducts?.length || 0} sous-produit(s)</span>
              </div>
            ))}
          </div>
        ) : (
          <p style={{ color: '#6c757d', textAlign: 'center', padding: '20px' }}>
            Aucun produit dans la base de données
          </p>
        )}
      </section>
    </div>
  );
}

export default ProductManager;